const GA_MEASUREMENT_ID = 'G-867C8YHDYV';

type GtagArgs = [string, ...unknown[]];

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: GtagArgs) => void;
  }
}

/** Loads Google Analytics (gtag.js) once and starts tracking key clicks */
export function initAnalytics(): void {
  if (typeof window === 'undefined' || document.getElementById('ga-gtag')) return;

  const script = document.createElement('script');
  script.id = 'ga-gtag';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag expects the raw arguments object
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  document.addEventListener('click', handleOutboundClick, { capture: true });
}

export function trackEvent(name: string, params: Record<string, unknown> = {}): void {
  if (typeof window.gtag === 'function') window.gtag('event', name, params);
}

function handleOutboundClick(event: MouseEvent): void {
  const link = (event.target as HTMLElement | null)?.closest('a');
  if (!link) return;
  const href = link.href;
  const section = link.closest('section')?.id || link.closest('header, footer')?.tagName.toLowerCase() || 'floating';

  if (href.includes('sub_confirmation=1')) {
    trackEvent('subscribe_click', { section });
    return;
  }

  const videoMatch = href.match(/youtube\.com\/(?:watch\?v=|shorts\/)([\w-]+)/);
  if (videoMatch) {
    trackEvent('video_click', {
      video_id: videoMatch[1],
      video_type: href.includes('/shorts/') ? 'short' : 'video',
      section,
    });
    return;
  }

  if (href.includes('youtube.com/')) {
    trackEvent('channel_click', { section, link_url: href });
  }
}
